import { routes as attendance } from '@/modules/attendance'
import { routes as auth } from '@/modules/auth'
import { routes as axis } from '@/modules/axis'
import { routes as calendar } from '@/modules/calendar'
import { routes as city } from '@/modules/city'
import { routes as diagnostic } from '@/modules/diagnostic'
import { routes as evidence } from '@/modules/evidence'
import { routes as groupSolution } from '@/modules/group-solution'
import { routes as paymentManagement } from '@/modules/payment-management'
import { routes as pmd } from '@/modules/pmd'
import { routes as project } from '@/modules/project'
import { routes as referenceTerm } from '@/modules/reference-term'
import { routes as report } from '@/modules/report'
import { routes as task } from '@/modules/task'
import { routes as user } from '@/modules/user'
import { routes as event } from '@/modules/event'
import { routes as administrativeReport } from '@/modules/administrative-report'
import { routes as administrativeDashboard } from '@/modules/administrative-dashboard'
import { routes as ur } from '@/modules/ur'
import { routes as eixos } from '@/modules/eixo'
import { routes as pacote } from '@/modules/pacote'
import { routes as tema } from '@/modules/tema'
import { routes as salaIndicadores } from '@/modules/sala-indicadores'
import { routes as salaIndicadoresMunicipio } from '@/modules/sala-indicadores-municipio'
import { routes as salaIndicadoresApuracao } from '@/modules/sala-indicadores-apuracao'
import { routes as salaIndicadoresFonte } from '@/modules/sala-indicadores-fonte'
import { routes as salaIndicadoresLeitura } from '@/modules/sala-indicadores-leitura'
import { routes as salaIndicadoresNivel } from '@/modules/sala-indicadores-nivel'
import { routes as salaIndicadoresUnidade } from '@/modules/sala-indicadores-unidade'
import { routes as salaPrincipal } from '@/modules/sala-principal'
import { routes as cargosFuncoes } from '@/modules/cargos-funcoes'
import { routes as sala5w2h } from '@/modules/sala-5w2h'
import { routes as salaCusto } from '@/modules/sala-custo'
import { routes as salaTempo } from '@/modules/sala-tempo'
import { routes as pergunta } from '@/modules/pergunta'
import { routes as medalha } from '@/modules/medalha'
import { routes as configuracoes } from '@/modules/configuracao'
import { routes as groups } from '@/modules/groups'
import { routes as agenteTerritorial } from '@/modules/agenteTerritorial'
import { routes as eixosGrupo } from '@/modules/eixosGrupo'
import { routes as municipiosPorEixos } from '@/modules/municipiosPorEixo'
import { routes as diagnosticoSelo } from '@/modules/diagnosticoSelo'
import { routes as tipoSolucao } from '@/modules/tipoSolucao'


export default [{
    path: '*',
    redirect: '/cidade'
},
...attendance,
...auth,
...axis,
...calendar,
...city,
...diagnostic,
...evidence,
...groupSolution,
...paymentManagement,
...pmd,
...project,
...referenceTerm,
...report,
...task,
...user,
...event,
...administrativeReport,
...administrativeDashboard,
...ur,
...eixos,
...pacote,
...tema,
...salaIndicadores,
...salaIndicadoresMunicipio,
...salaIndicadoresApuracao,
...salaIndicadoresFonte,
...salaIndicadoresLeitura,
...salaIndicadoresNivel,
...salaIndicadoresUnidade,
...salaPrincipal,
...cargosFuncoes,
...sala5w2h,
...salaCusto,
...salaTempo,
...pergunta,
...medalha,
...configuracoes,
...groups,
...agenteTerritorial,
...eixosGrupo,
...municipiosPorEixos,
...diagnosticoSelo,
...tipoSolucao
]
